import $ from 'jquery';
import Swiper from 'swiper';
import { Navigation, Autoplay, Mousewheel, EffectFade, Pagination, Grid } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';


let newsSlider = $('.news-slider__slider');

if (newsSlider.length > 0) {
  newsSlider.each(function () {
    let newsSliderSwiper = new Swiper(this, {
      modules: [Navigation, Autoplay, Mousewheel, EffectFade, Pagination, Grid],
      slidesPerView: 1,
      loop: false,
      wrapperClass: 'slider-news',
      autoplay: {
        delay: 5000,
        disableOnInteraction: true,
      },
      navigation: {
        nextEl: '.swiper-button-next-news', 
        prevEl: '.swiper-button-prev-news',
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true,
      },
    });

    $(this).mouseenter(function() {
      (this).swiper.autoplay.stop();
    });

    $(this).mouseleave(function() {
      (this).swiper.autoplay.start();
    });

    newsSliderSwiper.init();
  });
}

